// Articles contributed to Stacknot, a tech media site (author: ta-yoshida).
// `date` is the publish time (JST); the strip sorts by it. Thumbnails are the articles' own og:image files on the Stacknot CMS.
const ARTICLES = [
  {
    id: 'extenddb-postgresql',
    url: 'https://stacknot.east-cloud.jp/articles/extenddb-postgresql%E3%81%AF%E3%80%8Cdynamodb%E3%81%AE%E4%BB%A3%E3%82%8F%E3%82%8A%E3%80%8D%E3%81%AB%E3%81%AA%E3%82%8B%E3%81%8B-%E6%A4%9C%E8%A8%BC%E3%81%97%E3%81%A6%E6%8E%A1%E6%8A%9E',
    title: 'ExtendDB + PostgreSQLは「DynamoDBの代わり」になるか — 検証して採択した理由と、明確な欠点',
    date: '2026-08-28T17:36',
    image:
      'https://cms.east-cloud.jp/wp-content/uploads/2026/08/260828-6-stacknot-extenddb-article-thumbnail-1024x683.png',
  },
  {
    id: 'internal-rag-retirement',
    url: 'https://stacknot.east-cloud.jp/articles/%E7%A4%BE%E5%86%85%E6%96%87%E6%9B%B8rag%E3%82%92%E4%BD%9C%E3%81%A3%E3%81%A6%E3%80%812%E3%81%8B%E6%9C%88%E3%81%A7%E6%8D%A8%E3%81%A6%E3%81%9F-%E4%BD%9C%E3%81%A3%E3%81%A6%E6%8D%A8%E3%81%A6',
    title: '社内文書RAGを作って、2か月で捨てた — 作って捨てて分かった「索引の鮮度」問題',
    date: '2026-08-28T15:48',
    image:
      'https://cms.east-cloud.jp/wp-content/uploads/2026/08/260828-1-stacknot-internal-design-rag-retirement-thumbnail-1024x683.png',
  },
  {
    id: 'sakura-spa-deep-link',
    url: 'https://stacknot.east-cloud.jp/articles/%E3%81%95%E3%81%8F%E3%82%89%E3%81%AE%E3%82%AF%E3%83%A9%E3%82%A6%E3%83%89%E3%81%ABcloudfront%E3%81%AE%E3%80%8C%E3%81%82%E3%81%AE404%E5%AF%BE%E7%AD%96%E3%80%8D%E3%81%AF%E3%81%AA%E3%81%84-spa-d',
    title: 'さくらのクラウドにCloudFrontの「あの404対策」はない — SPA deep linkの壁とAppRunゲートウェイという現実解',
    date: '2026-08-01T19:42',
    image:
      'https://cms.east-cloud.jp/wp-content/uploads/2026/08/sakura-spa-deep-link-404-article-thumbnail-1024x683.jpg',
  },
  {
    id: 'genai-on-sakura-mvp',
    url: 'https://stacknot.east-cloud.jp/articles/%E6%94%BF%E5%BA%9Cai%E3%80%8C%E6%BA%90%E5%86%85%E3%80%8D%E3%81%AF%E3%81%95%E3%81%8F%E3%82%89%E3%81%AE%E3%82%AF%E3%83%A9%E3%82%A6%E3%83%89%E3%81%A7%E5%8B%95%E3%81%8F%E3%81%AE%E3%81%8B-oss',
    title: '政府AI「源内」はさくらのクラウドで動くのか — OSS公開から3か月、国産クラウドでMVPを動かすまで',
    date: '2026-07-24T17:24',
    image:
      'https://cms.east-cloud.jp/wp-content/uploads/2026/08/genai-on-sakura-mvp-article-thumbnail-v2-1024x683.jpg',
  },
];

export default ARTICLES;
